export default __webpack_public_path__ + "static/media/with.13369208.mp4";